import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './MobileNavigationNode.scss';
import classNames from 'classnames';

import {Link} from 'react-router';

/**
 * Node of aside component list
 * It can be link or button with custom action
 */
export default class MobileNavigationNode extends Component {
    static TYPE_LINK = 'link';
    static TYPE_BUTTON = 'button';

    static propTypes = {
        type: PropTypes.string.isRequired,
        label: PropTypes.string,
        to: PropTypes.string,
        action: PropTypes.func,
        onClick: PropTypes.func
    };

    renderAsLink() {
        const {label, to, active, onClick} = this.props;

        const className = classNames(styles.node, {[styles.active]: active});

        return (
            <div className={className}>
                <Link to={to} className={styles.nodeElement} onClick={onClick}>
                    <span className={styles.label}>{label}</span>
                </Link>
            </div>
        );
    }

    onActionClick() {
        this.props.onClick && this.props.onClick();
        this.props.action && this.props.action();
    }

    renderAsButton() {
        const {label} = this.props;

        const className = classNames(styles.node, styles.btn);

        return (
            <div className={className}>
                <span onClick={::this.onActionClick}
                      className={styles.nodeElement}>{label}</span>
            </div>
        )

    }

    render() {
        if (this.props.type === MobileNavigationNode.TYPE_LINK) {
            return this.renderAsLink();
        } else {
            return this.renderAsButton();
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/Header/Mobile/MobileNavigationNode.js